module.exports = __webpack_public_path__ + "static/media/Icon_money.4662e71f.svg";